import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import Layout and Page Components
import Layout from './components/Layout/Layout';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CareerPage from './pages/CareerPage';
import CaseStudiesPage from './pages/CaseStudiesPage';

function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        {/* This is a dynamic route. ':serviceId' is a URL parameter. */}
        <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/career" element={<CareerPage />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />
      </Routes>
    </Layout>
  );
}

export default App;
